import { getProductVariantId } from "./productOptions";

export const getProductDetailLink = (product, context = {}) => {
  const { cartContext = {}, ...navigation } = context;
  const id = getProductVariantId(product);
  const segmentId = navigation.segmentId || product.segment_id || cartContext.segment_id || "";
  const businessSegmentId = navigation.businessSegmentId || product.business_segment_id || cartContext.business_segment_id || "";
  const search = new URLSearchParams();
  if (segmentId) search.set("segment_id", segmentId);
  if (businessSegmentId) search.set("business_segment_id", businessSegmentId);
  const path = id ? `/productdetail/${encodeURIComponent(id)}` : "/productdetail";
  return {
    to: `${path}${search.toString() ? `?${search.toString()}` : ""}`,
    state: {
      ...navigation,
      product,
      cartContext,
      segmentId,
      businessSegmentId,
    },
  };
};
